// MIT © 2017 azu
"use strict";
// 「サ入れ」方向の検出
//  動詞＋助動詞「たい」＋「そう」の形式は、本来どこをとっても「サ」が入る余地の無い
// 形式のはずだが、何故か「サ」が入る例が散見される
// http://www.anlp.jp/proceedings/annual_meeting/2012/pdf_dir/B1-2.pdf
export default [
    {
        message: "不要な「さ」が挿入されています。",
        expected: "$2$3",
        // https://azu.github.io/morpheme-match/?text=寿司が美味しさそう。
        tokens: [
            {
                "conjugated_form": "ガル接続",
                "basic_form": ["辛い", "美味しい", "寒い"],
                "_capture": "$2"
            },
            {
                "surface_form": "さ",
                "_index": true
            },
            {
                "basic_form": "そう",
                "pos_detail_1": ["接尾", "助詞類接続"],
                "_capture": "$3"
            }
        ]
    },
    {
        message: "不要な「さ」が挿入されています。",
        expected: "$1$2$3",
        // https://azu.github.io/morpheme-match/?text=早く終わらせて(帰りたさそう)なのがおかしかった.
        // https://azu.github.io/morpheme-match/?text=刺し身をたべたさそう。
        tokens: [
            {
                "pos": "動詞",
                "_capture": "$1"
            },
            {
                "surface_form": "た",
                "pos": "助動詞",
                // basic_formが"たい"ではない場合がある
                "_capture": "$2"
            },
            {
                "surface_form": "さ",
                "_index": true
            },
            {
                "basic_form": "そう",
                "pos_detail_1": ["接尾", "助詞類接続"],
                "_capture": "$3"
            }
        ]
    }
];
